import { connect } from 'react-redux';
import { compose } from 'redux';
import { useHistory } from 'react-router-dom';
import { mapProps } from 'modules/shell/hoc/mapProps';
import { withFeatureToggles } from 'modules/shell/hoc/withFeatureToggles';
import { withRestoreScrollPosition } from 'modules/shell/hoc/withRestoreScrollPosition';
import {
  VOIDS_FOR_ORDER_DETAILS_PAGE,
  STORE_SENDS_RECEIPTS,
  VERTEX_O,
  MAO_INVENTORY,
} from 'constants/featureToggleNames';
import OrderDetailsPage from './OrderDetailsPage';
import {
  setOrderDetails,
  getProductsForOrder,
  resetOrderDetails,
  getOrderDetails,
  getFailedOrderDetails,
  addCachedOrderData,
  voidOrder,
  sendGiftReceipt,
} from '../../actions/orderActions';

const mapStateToProps = ({ clientsModule, user, generalManagerStores }, { match }) => {
  const { orderId, channel } = match.params;
  const { data, confirmationData, loading, error } = clientsModule.orderDetails;
  const { brand } = user?.data;
  const { selectedStore } = generalManagerStores;
  return {
    orderDetailsData: data,
    confirmationData,
    orderId,
    channel,
    userBrand: brand,
    loading,
    error,
    selectedStoreId: selectedStore[brand]?.storeId,
  };
};

const mapDispatchToProps = {
  setOrderDetails,
  getProductsForOrder,
  resetOrderDetails,
  getOrderDetails,
  getFailedOrderDetails,
  addCachedOrderData,
  voidOrder,
  sendGiftReceipt,
};

const withMappedProps = mapProps(
  ({
    channel,
    orderId,
    orderDetailsData,
    getOrderDetails,
    getFailedOrderDetails,
    isMAOInventoryEnabled,
    ...ownProps
  }) => {
    const history = useHistory();
    const isFailedOrder = history?.location?.state?.orderFailed;

    const fetchData = async (orderId, channel) => {
      if (isFailedOrder) {
        await getFailedOrderDetails(orderId);
      } else {
        const versionSelected = { version: isMAOInventoryEnabled ? 'v4' : 'v3' };
        await getOrderDetails({ orderId, channelCode: channel, ...versionSelected });
      }
    };

    return {
      fetchData,
      addCachedOrderData,
      data: orderDetailsData,
      orderId,
      channel,
      getFailedOrderDetails,
      history,
      isFailedOrder,
      ...ownProps,
    };
  },
);

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withFeatureToggles({
    isVoidForOrderDetailsEnabled: VOIDS_FOR_ORDER_DETAILS_PAGE,
    isDeliveryReceiptCopyEnabled: STORE_SENDS_RECEIPTS,
    isVertexOEnabled: VERTEX_O,
    isMAOInventoryEnabled: MAO_INVENTORY,
  }),
  withMappedProps,
  withRestoreScrollPosition(),
)(OrderDetailsPage);
